import { getPlanApiUrl, getCurrentPlanEnvironment } from '../helpers/planConfig';

const ODD_PORTAL_PROD_URL = 'https://www.findbugzero.com';
// dev2 has no ODD website (frontend_enabled: false in marketing's stages.yaml),
// so Plan on dev2 links to the dev site.
const ODD_PORTAL_DEV_URL = 'https://dev-odd.findbugzero.com';

export default {
  get api() {
    const url = getPlanApiUrl();
    console.log('ODD API URL resolved to:', url);
    return url;
  },
  get portalUrl() {
    return getCurrentPlanEnvironment() === 'prod' ? ODD_PORTAL_PROD_URL : ODD_PORTAL_DEV_URL;
  }
};
